import React from 'react';

const InquiryProduct = ({ product, inquiryQuantity, claimAmount, expiryDate,status,buyerRequested,buyer,inquiryId }) => {
  const {
    image,
    title,
    price
  } = product;

  return (
    <div className="card rounded-4">
      <div className="card-body p-4">
        <div className="row align-items-center">
          <div className="col-lg-3 col-md-4 col-12 text-center">
            <img src={image} alt={title} className="img-fluid rounded"  />
          </div>
          <div className="col-lg-9 col-md-4 col-12">
            <p className="fw-bold mb-2">{title}</p>
            <div className="row">
              <div className="col-12">
                  <p><strong>Quantity:</strong> {inquiryQuantity}</p>
                  <p><strong>Price:</strong> £{price?.toFixed(2)}</p>
                  <p><strong>Claim Amount:</strong> £{claimAmount?.toFixed(2)}</p>
                  <p><strong>Expiry Date:</strong> {expiryDate}</p>
                  <p><strong>Status:</strong> {status}</p>
              </div>
              
              <div className="col-12" style={{paddingTop: '10px'}}>
                <h6 className="mb-4">
                    Buyer Requested{" "}
                </h6>
                  <p>{buyerRequested || "No specific request."}</p>
                  <p><strong>Buyer:</strong> {buyer || "N/A"}</p>
                  <p><strong>Inquiry ID:</strong> {inquiryId || "N/A"}</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default InquiryProduct;
